import { render, staticRenderFns } from "./customer-drawer.vue?vue&type=template&id=4c3e1ec0&scoped=true"
import script from "./customer-drawer.vue?vue&type=script&lang=js"
export * from "./customer-drawer.vue?vue&type=script&lang=js"
import style0 from "./customer-drawer.vue?vue&type=style&index=0&id=4c3e1ec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3e1ec0",
  null
  
)

export default component.exports